import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { ErrorBoundary, scheduleReloadWithBackoff } from './ErrorBoundary';
import { registerServiceWorker } from './cache/sw-register';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

// Global safety net (#178): an unattended kiosk must never sit on a dead page.
// Uncaught errors and unhandled promise rejections that escape React (async
// callbacks, event handlers, MQTT/fetch tasks) are logged and trigger the same
// reload-with-backoff used by the ErrorBoundary.
window.addEventListener('error', (event) => {
  console.error('[Player] Uncaught error:', event.error ?? event.message);
  scheduleReloadWithBackoff();
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Player] Unhandled promise rejection:', event.reason);
  scheduleReloadWithBackoff();
});

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// Register Service Worker for offline caching
registerServiceWorker().catch((err) => {
  console.warn('Service Worker registration failed:', err);
});
